<template>
    <div>
        <nav>
            <v-app-bar
                    app
                    clipped-left
                    color="blue"
            >
                <v-app-bar-nav-icon @click="drawer = !drawer"/>
                <v-avatar @click="drawer = !drawer" size="45">
                    <img src="/logo.png">
                </v-avatar>
                <span class="headline ml-3 mr-5 hidden-xs-only font-weight-black" smAndDown=false>OS&nbsp;<span
                        class="font-weight-light">ADMIN</span> <span
                        class="subtitle-2 red darken-4">{{api}}</span> </span>
                <v-text-field @input="fireEvent"
                              class="ml-2"
                              clearable
                              flat
                              hide-details
                              label="Volltextsuche"
                              prepend-inner-icon="fab fa-searchengin"
                              solo-inverted
                />

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn @click="newCustomerCofig.show=true" class="ml-1" rounded text v-on="on">
                            <v-icon left small>fas fa-user-plus</v-icon>
                            <span class="hidden-xs-only">Kunden hinzufügen</span>

                        </v-btn>
                    </template>
                    <span>Kunden hinzufügen</span>
                </v-tooltip>


                <v-spacer/>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn @click="logout" rounded text v-on="on">
                            <span class=" hidden-xs-only">Ausloggen</span>
                            <v-icon right small>fas fa-sign-out-alt</v-icon>
                        </v-btn>
                    </template>
                    <span>Ausloggen</span>
                </v-tooltip>

            </v-app-bar>

            <v-navigation-drawer
                    app
                    clipped
                    color="grey lighten-4"
                    v-model="drawer">
                <v-list class="grey lighten-4" dense>
                    <v-list-item link to="/">
                        <v-list-item-action>

                            <v-icon>fas fa-users</v-icon>
                            <v-badge
                                    :content="cCount"
                                    color="red  ">
                            </v-badge>

                        </v-list-item-action>
                        <v-list-item-content>


                            <v-list-item-title class="grey--text">
                                Kunden Übersicht
                            </v-list-item-title>


                        </v-list-item-content>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon @click="refresh" color="blue">fas fa-sync-alt</v-icon>
                                </v-btn>
                            </template>
                            <span>Refresh</span>
                        </v-tooltip>
                    </v-list-item>


                </v-list>

            </v-navigation-drawer>


        </nav>
        <new-customer :show-popup="newCustomerCofig" v-if="newCustomerCofig.show"></new-customer>
    </div>
</template>

<script>

    import {EventBus} from '../eventbus'
    import NewCustomer from "./NewCustomer";
    import {HTTP} from "../http";

    export default {
        components: {NewCustomer},
        props: {
            source: String,
        },
        computed: {
            api() {
                let api = HTTP.defaults.baseURL;

                if (api.toLowerCase().indexOf("testapi") != -1){
                    return 'TEST'
                }
                if (api.toLowerCase().indexOf("licadminapi") != -1){
                    return 'PROD'
                }
                return '';
            }
        },
        methods: {
            refresh() {
                EventBus.$emit('reload');
            },
            logout() {
                localStorage.removeItem("ridtoken");
                this.$router.push("/login");
            },
            fireEvent(event) {
                EventBus.$emit('on-search', event);
            }
        },
        data: () => ({
            cCount: "",
            newCustomerCofig: {
                show: false
            },
            drawer: null,

        }),
        created() {
            EventBus.$on('update-counter', value => {
                this.cCount = value;
            });
        },
    }
</script>

<style>
    #keep .v-navigation-drawer__border {
        display: none
    }
</style>